// apps/patient/src/components/programs/SubstitutionBanner.tsx

import { Info, RefreshCw } from 'lucide-react';
import { ExerciseSubstitution } from '@prism-ehr/shared';

interface SubstitutionBannerProps {
  substitution: ExerciseSubstitution;
  onViewOriginal?: () => void;
  compact?: boolean;
}

export function SubstitutionBanner({
  substitution,
  onViewOriginal,
  compact = false
}: SubstitutionBannerProps) {
  if (compact) {
    return (
      <div className="flex items-center gap-2 px-3 py-1.5 bg-blue-50 border border-blue-200 rounded-lg text-sm">
        <RefreshCw className="h-3.5 w-3.5 text-blue-500 flex-shrink-0" />
        <span className="text-blue-700">
          Substituted for <span className="font-medium">{substitution.original_exercise_name}</span>
        </span>
      </div>
    );
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
      <div className="flex items-start gap-3">
        <div className="p-1.5 bg-blue-100 rounded-full">
          <RefreshCw className="h-4 w-4 text-blue-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-blue-800">
            Exercise Substituted
          </p>
          <p className="text-sm text-blue-700 mt-0.5">
            This replaces <span className="font-medium">{substitution.original_exercise_name}</span>
          </p>
          {substitution.equipment_missing && substitution.equipment_missing.length > 0 && (
            <p className="text-xs text-blue-600 mt-1">
              Missing equipment: {substitution.equipment_missing.join(', ')}
            </p>
          )}
        </div>
        {onViewOriginal && (
          <button
            onClick={onViewOriginal}
            className="text-xs text-blue-700 hover:text-blue-800 hover:underline whitespace-nowrap"
          >
            View Original
          </button>
        )}
      </div>
    </div>
  );
}
